import { useRef } from 'react';
export const useStableFunction = fn => {
  const currentFnRef = useRef(fn);
  const stableFnRef = useRef(undefined);

  // eslint-disable-next-line react-hooks/refs
  currentFnRef.current = fn;

  // eslint-disable-next-line react-hooks/refs
  if (!stableFnRef.current) {
    stableFnRef.current = function (...args) {
      return currentFnRef.current.call(this, ...args);
    };
  }

  // eslint-disable-next-line react-hooks/refs
  return stableFnRef.current;
};